/* eslint-disable no-restricted-imports */
import React from 'react'
import { useI18next } from '@toasttab/shared/src/hooks/useI18next'
import { ReactComponent as Facebook } from '@toasttab/shared/src/assets/svg/footer/facebook.svg'
import { ReactComponent as Instagram } from '@toasttab/shared/src/assets/svg/footer/instagram.svg'
import { ReactComponent as LinkedIn } from '@toasttab/shared/src/assets/svg/footer/linkedin.svg'
import { ReactComponent as TikTok } from '@toasttab/shared/src/assets/svg/footer/tiktok.svg'
import { ReactComponent as X } from '@toasttab/shared/src/assets/svg/footer/x.svg'
import { ReactComponent as YouTube } from '@toasttab/shared/src/assets/svg/footer/youtube.svg'
import { FooterSocialIconsProps, SocialIcons } from './Footer.d'

export const renderSocialSVG = (icon: string) => {
  const cssClasses = 'text-secondary fill-secondary'
  const testId = `FooterSocialIcons-icon-${icon}`
  switch (icon) {
    case 'Facebook':
      return <Facebook className={cssClasses} data-testid={testId} />
    case 'Instagram':
      return <Instagram className={cssClasses} data-testid={testId} />
    case 'LinkedIn':
      return <LinkedIn className={cssClasses} data-testid={testId} />
    case 'TikTok':
      return <TikTok className={cssClasses} data-testid={testId} />
    case 'X':
      return <X className={cssClasses} data-testid={testId} />
    case 'YouTube':
      return <YouTube className={cssClasses} data-testid={testId} />
    default:
      return null
  }
}

const FooterSocialIcons = ({ socialIcons }: FooterSocialIconsProps) => {
  const { t } = useI18next()

  return (
    <ul className='flex items-center' data-testid='FooterSocialIcons'>
      {socialIcons.map(({ text, href }: SocialIcons) => {
        const icon = renderSocialSVG(text)
        return icon ? (
          <li key={`footerSocialIcons-${text}`} className='mr-2.5'>
            <a
              className='hide-external-icon'
              data-testid={`FooterSocialIcons-link-${text}`}
              href={href}
              title={t(`Toast on ${text}`)}
            >
              {renderSocialSVG(text)}
            </a>
          </li>
        ) : (
          <></>
        )
      })}
    </ul>
  )
}

export default FooterSocialIcons
